<div class="page-content">
  <app-page-header
    [headline]="'DEFINE.VALUE_ANALYSIS.TITLE'"
    [subheadline]="'DEFINE.VALUE_ANALYSIS.SUBTITLE'"
    [spaceName]="space?.name || ''">
    <ng-content></ng-content>
  </app-page-header>

  <div class="page-scroll-content">
    <app-notes [visible]="showNotes"></app-notes>
    @if (space) {
      <app-roi-calculation
        [teamSize]="space.teamSize"
        [averageHourlyRate]="space.averageHourlyRate"
        [projectsPerYear]="space.projectsPerYear"
        [averageLicenceCost]="space.averageLicenceCost"
        [currencyCode]="space.currencyCode ?? 'EUR'"
        [maturityLevel]="space.maturityLevel"
        [productivityGainPercent]="space.productivityGainPercent"
        [reworkReductionPercent]="space.reworkReductionPercent"
        [coordinationSavingsPercent]="space.coordinationSavingsPercent"
        (teamSizeChange)="onRoiFieldChange('teamSize', $event)"
        (averageHourlyRateChange)="onRoiFieldChange('averageHourlyRate', $event)"
        (projectsPerYearChange)="onRoiFieldChange('projectsPerYear', $event)"
        (averageLicenceCostChange)="onRoiFieldChange('averageLicenceCost', $event)"
        (maturityLevelChange)="onRoiFieldChange('maturityLevel', $event)"
        (productivityGainPercentChange)="onRoiFieldChange('productivityGainPercent', $event)"
        (reworkReductionPercentChange)="onRoiFieldChange('reworkReductionPercent', $event)"
        (coordinationSavingsPercentChange)="onRoiFieldChange('coordinationSavingsPercent', $event)">
      </app-roi-calculation>
    }

    <app-page-footer></app-page-footer>
  </div>
</div>
